import { render } from "./MemberApplicationTabDataDiri.vue?vue&type=template&id=12b3fb66&scoped=true"
import script from "./MemberApplicationTabDataDiri.vue?vue&type=script&lang=js"
export * from "./MemberApplicationTabDataDiri.vue?vue&type=script&lang=js"

import "./MemberApplicationTabDataDiri.vue?vue&type=style&index=0&id=12b3fb66&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b3fb66"]])

export default __exports__